function f(t) {
  const e = new DOMParser().parseFromString(t, "text/html");
  return Array.from(e.body.children);
}
function l(t) {
  const r = document.createElement("noscript"), e = document.createElement("img");
  return e.src = t, e.alt = "", e.referrerPolicy = "no-referrer-when-downgrade", r.appendChild(e), r;
}
function u(t, r, e) {
  const a = document.createElement("script");
  return a.id = t, a.setAttribute("src", r), e != null && e.defer && (a.defer = !0, a.async = !0), e != null && e.onload && a.setAttribute("onload", e.onload), e != null && e.onloadFn && a.addEventListener("onload", e.onloadFn), e != null && e.data && Object.keys(e.data).forEach((c) => {
    var d;
    a.setAttribute(`data-${c}`, ((d = e.data) == null ? void 0 : d[c]) ?? "");
  }), a;
}
function n(t, r) {
  const e = document.createElement("script");
  return e.innerText = t, e.type = "application/javascript", r != null && r.defer && (e.defer = !0), r != null && r.data && Object.keys(r.data).forEach((a) => {
    var c;
    e.setAttribute(`data-${a}`, ((c = r.data) == null ? void 0 : c[a]) ?? "");
  }), e;
}
export {
  f as createHtmlElements,
  n as createInlineScript,
  l as createNoScript,
  u as createScript
};
